import React, { useContext } from 'react'
import { Modal, Form, Input, Select, Button } from 'antd'
import { AppContext } from 'AppContext'
import { getName, canUserEdit, canUserAdd, canUserSave } from 'utils/User'
import { GET_ALL_CLIENT } from '../../Users/graphql/Queries'
import { useQuery } from '@apollo/react-hooks'
import Page404 from 'components/Page404'

const { Option } = Select

const CollectionCreateForm = ({
  visible,
  onCreate,
  onUpdate,
  onCancel,
  isEdit,
  selectedGroup,
}) => {
  const { state: { currentUser, userPermissions, isClient } = {} } = useContext(AppContext) || {}
  const hasEdit = canUserEdit(userPermissions || currentUser, isClient)
  const hasAdd = canUserAdd(userPermissions || currentUser, isClient)
  const hasSave = canUserSave(userPermissions || currentUser, isClient)
  const canSubmit = isEdit ? (hasEdit && hasSave) : (hasAdd && hasSave)

  const [form] = Form.useForm()
  const [clientCode, setClientCode] = React.useState([])

  function resetForm() {
    form.resetFields()
  }

  const { data, loading, error } = useQuery(GET_ALL_CLIENT, {
    variables: {
      where: {},
      limit: 1000000,
    },
    fetchPolicy: 'network-only',
  })

  if (error) return <Page404 />

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData
    const pastedData = clipboardData.getData('Text')?.trim()?.split(',')
    let selectedUserIds = []
    if (data?.getClientUsers?.users) {
      selectedUserIds = data.getClientUsers.users
        .filter(
          (user) =>
            user?.clientCode && // Ensure clientCode exists before calling toLowerCase()
            pastedData.some(
              (code) => code?.toLowerCase() === user.clientCode.toLowerCase()
            )
        )
        .map((user) => user.id)
    }

    setClientCode(selectedUserIds)
    form.setFieldsValue({ userIds: selectedUserIds })
    if (selectedUserIds.length) event.clipboardData = null
  }

  const handleSelect = (value) => {
    setClientCode(value)
    form.setFieldsValue({ userIds: value })
  }
  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title={isEdit ? 'Edit Group' : 'Add New Group'}
      okText={isEdit ? 'Update Group' : 'Add Group'}
      cancelText='Cancel'
      onCancel={() => {
        resetForm()
        onCancel()
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            if (isEdit) {
              onUpdate(values, resetForm)
            } else {
              onCreate(values, resetForm)
            }
          })
          .catch((info) => console.log('Validate Failed:', info))
      }}
    >
      <Form
        form={form}
        layout='vertical'
        name='form_in_modal'
        initialValues={{
          modifier: 'public',
          ...selectedGroup,
        }}
      >
        <Form.Item
          name='name'
          label='Group Name'
          rules={[
            {
              required: true,
              message: 'Please input your group name!',
              whitespace: true,
            },
          ]}
          hasFeedback
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='userIds'
          label='Select Users'
          rules={[{ required: true, message: 'Please select users!' }]}
          // hasFeedback
        >
          <Select
            mode='multiple'
            loading={loading}
            filterOption={true}
            optionFilterProp='title'
            style={{ width: '100%' }}
            placeholder='Please select users'
            onChange={handleSelect}
            onPaste={handlePaste}
            value={clientCode} // Stores only user IDs now
            // allowClear
          >
            {!loading &&
              data?.getClientUsers?.users.map((user) => (
                <Option
                  key={user.id}
                  value={user.id}
                  title={`${user.clientCode} - ${getName(user)}${
                    user?.plan?.name ? ` - ${user.plan.name}` : ''
                  }`}
                >
                  {user.clientCode} - {getName(user)}
                  {user?.plan?.name ? ` - ${user.plan.name}` : ''}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <div className='footer-btn-div'>
          <Button
            className='footer-cancel-btn'
            onClick={() => {
              resetForm()
              onCancel()
            }}
          >
            Cancel
          </Button>
          <Button
            className='footer-cancel-btn'
            onClick={() => {
              form.setFieldsValue({ userIds: [] })
              setClientCode([])
            }}
          >
            Remove All
          </Button>
          <Button
            className='footer-submit-btn'
            onClick={() => {
              if (!canSubmit) return
              form
                .validateFields()
                .then((values) => {
                  if (isEdit) {
                    onUpdate(values, resetForm)
                  } else {
                    onCreate(values, resetForm)
                  }
                })
                .catch((info) => console.log('Validate Failed:', info))
            }}
            type='primary'
            disabled={!canSubmit}
          >
            {isEdit ? 'Update Group' : 'Add Group'}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

const CreateGroupModal = (props) => {
  return (
    <div>
      <CollectionCreateForm {...props} />
    </div>
  )
}

export default CreateGroupModal
